import { render } from "./DetailsSection.vue?vue&type=template&id=0cbfcfcc"
import script from "./DetailsSection.vue?vue&type=script&lang=js"
export * from "./DetailsSection.vue?vue&type=script&lang=js"

import "./DetailsSection.vue?vue&type=style&index=0&id=0cbfcfcc&lang=scss"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__